module.exports = __webpack_public_path__ + "static/media/Strudel-BitcoinCash-Etherium-Icon.86a2212e.png";